import type { ApiError } from '@/api/client'
import type { CannotSendReason } from '@/api/types'
import type { MessageKey } from '@/i18n'

/** 不能发私信的原因 → 给人看的话。服务端的 message 是中文原文，界面要跟着语言走 */
export const CANNOT_SEND_TEXT: Record<CannotSendReason, MessageKey> = {
  dm_not_allowed: 'messages.cannotSendNotAllowed',
  blocked: 'messages.cannotSendBlocked',
  inactive: 'messages.cannotSendInactive',
}

export function cannotStartMessage(error: ApiError, t: (key: MessageKey) => string): string {
  if (error.code === 'dm_not_allowed') return t('messages.cannotSendNotAllowed')
  if (error.code === 'blocked') return t('messages.cannotSendBlocked')
  if (error.status === 404) return t('messages.userNotFound')
  if (error.code === 'cannot_message_self') return t('messages.cannotMessageSelf')
  return error.message
}
